import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '../../../redux/reducers';
import { StateStatus } from '../../utils/common';
import * as NotificationService from 'services/api/notification';
import { useSelector } from 'react-redux';

interface ICountry {
  country_id: number;
  code: string;
  description: string;
  numeric_code: number;
}

export interface ReimbursementsListOutput {
  status: StateStatus;
  data: NotificationService.ReminderListData | null;
}

export const useGetReimbursementsList = (): ReimbursementsListOutput => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.REIMBURSEMENTS_LIST_REDUCER].ReimbursementsList
  );
  return data;
};

export const useGetUnreadNotificationCount = (): number => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.REIMBURSEMENTS_LIST_REDUCER].unreadNotificationCount
        .data
  );
  return data;
};
